import script from "./UnitTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitTable.vue?vue&type=script&setup=true&lang=js"

import "./UnitTable.vue?vue&type=style&index=0&id=2602ccc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2602ccc2"]])

export default __exports__